import { SleepNurseryDomainService } from './domain';
import { SleepFactory } from './entity/sleepFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { SleepJson } from '@/types/domain/sleep/entities/sleepEntity';

/**
 * 睡眠アプリケーションサービス(施設)
 */
export class SleepNurseryApplicationService {
  private service!: SleepNurseryDomainService;

  private SleepFactory = new SleepFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new SleepNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurserySleep
   * @param input input
   */
  async sendNurserySleep(
    input: SleepJson,
  ) {
    const entity = this.SleepFactory.createFromJson(input);
    await this.service.sendNurserySleep(entity);
  }

  /**
   * removeNurserySleep
   * @param input input
   */
  async removeNurserySleep(
    input: SleepJson,
  ) {
    const entity = this.SleepFactory.createFromJson(input);
    await this.service.removeNurserySleep(entity);
  }
}
